module.exports = __webpack_public_path__ + "media/images/fr_ca/nurture_growth-4f29590b539ccd99bd989b57751585d2.png";